import React, { Fragment } from 'react';

import LargeGrid from './LargeGrid';
import SmallGrid from './SmallGrid';

const MeetSanctionGrid = ({data, isLoading, onSanctionClicked}) => (
  <Fragment>
    <LargeGrid data={data} isLoading={isLoading} onSanctionClicked={onSanctionClicked}/>
    <SmallGrid data={data} isLoading={isLoading} onSanctionClicked={onSanctionClicked}/>
  </Fragment>
);

export default MeetSanctionGrid;